import { useInputs } from '@hooks/use-inputs';
import useTranslation, { format } from '@translation-utils/use-translation';
import { CompareWithSavingsAccountCheckbox } from '../calculator-controls/inputs/compare-with-savings-account-checkbox';
import { PanelHeader } from '../panel-header/panel-header';

import './totals-panel.scss';
import { useCalculatedResults } from '@react-query/hooks/use-calculated-results';
import { AboutCalculations } from './about-calculations-info-button';
import { FundTotals, InvestmentTotals, SavingsAccountTotals } from './totals';

export const TotalsPanel = () => {
    const { savedAmountInXYears } = useTranslation();
    const { calcInputs } = useInputs();
    const { isFetching } = useCalculatedResults();

    const title = format(savedAmountInXYears, calcInputs.savingPeriodYears ?? 0);

    return (
        <section>
            <PanelHeader title={title} showIsLoading={isFetching} />
            <div className="totals-panel">
                <InvestmentTotals />
                <FundTotals />
                <SavingsAccountTotals />
                <div className="totals-panel__compare">
                    <CompareWithSavingsAccountCheckbox />
                </div>
                <AboutCalculations />
            </div>
        </section>
    );
};
